module.exports = __webpack_public_path__ + "img/about.f4c45c9a.jpg";